import React, { useState, useEffect, useRef } from "react";

import "./App.css";

import logo from "./assets/vedai.png";

import {
  signInWithPopup,
  signOut,
  onAuthStateChanged,
} from "firebase/auth";

import { auth, provider } from "./firebase";

function App() {
  const [user, setUser] = useState(null);

  const [message, setMessage] = useState("");

  const [messages, setMessages] = useState([
    {
      role: "assistant",
      content:
        "Hello 👋 I am VedAI. How can I help you today?",
    },
  ]);

  const [loading, setLoading] = useState(false);

  const messagesEndRef = useRef(null);

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(
      auth,
      (currentUser) => {
        setUser(currentUser);
      }
    );

    return () => unsubscribe();
  }, []);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({
      behavior: "smooth",
    });
  }, [messages]);

  // GOOGLE LOGIN

  const handleGoogleLogin = async () => {
    try {
      await signInWithPopup(auth, provider);
    } catch (error) {
      console.log(error);
      alert("Login failed");
    }
  };

  // LOGOUT

  const handleLogout = async () => {
    await signOut(auth);
  };

  // SEND MESSAGE

  const sendMessage = async () => {
    if (!message.trim()) return;

    const userMessage = {
      role: "user",
      content: message,
    };

    setMessages((prev) => [...prev, userMessage]);

    const currentMessage = message;

    setMessage("");

    setLoading(true);

    try {
      const response = await fetch(
        "https://192.248.185.50:5000/ai-reply",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            message: currentMessage,
          }),
        }
      );

      const data = await response.json();

      const aiMessage = {
        role: "assistant",
        content:
          data.reply ||
          data.error ||
          "No response",
      };

      setMessages((prev) => [
        ...prev,
        aiMessage,
      ]);
    } catch (error) {
      console.log(error);

      setMessages((prev) => [
        ...prev,
        {
          role: "assistant",
          content:
            "VedAI server error occurred.",
        },
      ]);
    }

    setLoading(false);
  };

  return (
    <div className="app">
      {/* SIDEBAR */}

      <div className="sidebar">
        <div>
          <img
            src={logo}
            alt="VedAI"
            className="main-logo"
          />

          <h1 className="logo">VedAI</h1>

          <p className="tagline">
            Intelligent AI Assistant
          </p>

          {user && (
            <div className="profile">
              <img
                src={user.photoURL}
                alt=""
                className="profile-img"
              />

              <div>
                <div className="profile-name">
                  {user.displayName}
                </div>

                <div className="profile-email">
                  {user.email}
                </div>
              </div>
            </div>
          )}
        </div>

        <div>
          {!user ? (
            <button
              className="login-btn"
              onClick={handleGoogleLogin}
            >
              Sign in with Google
            </button>
          ) : (
            <button
              className="logout-btn"
              onClick={handleLogout}
            >
              Logout
            </button>
          )}
        </div>
      </div>

      {/* MAIN */}

      <div className="main">
        {/* TOP BAR */}

        <div className="topbar">
          <div className="topbar-title">
            VedAI Assistant
          </div>

          <div className="topbar-status">
            ● Online
          </div>
        </div>

        {/* CHAT */}

        <div className="chat-area">
          {messages.map((msg, index) => (
            <div
              key={index}
              className={
                msg.role === "user"
                  ? "message user"
                  : "message ai"
              }
            >
              {msg.content}
            </div>
          ))}

          {loading && (
            <div className="message ai">
              VedAI is thinking...
            </div>
          )}

          <div ref={messagesEndRef} />
        </div>

        {/* INPUT */}

        <div className="input-area">
          <input
            type="text"
            placeholder="Ask VedAI anything..."
            value={message}
            onChange={(e) =>
              setMessage(e.target.value)
            }
            onKeyDown={(e) => {
              if (e.key === "Enter") {
                sendMessage();
              }
            }}
          />

          <button onClick={sendMessage}>
            Send
          </button>
        </div>
      </div>
    </div>
  );
}

export default App;